import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    IAdminToolPanel, UpgradeHelper,AdminToolPanelHelper, IExportZip,AdminToolHelper
} from '../../../helpers';
import { NO_VALUE_OPERATORS } from '../../../constants';
import { Button, ButtonType } from 'office-ui-fabric-react';
import { PanelHeader } from '../../admintool/panelheader';
interface IProps {
    adminToolState: any;
    panelName: string;
    isDisplayed: boolean
}
export class ZipList extends React.Component<IProps, any> {
    componentDidMount() {
       AdminToolPanelHelper.SetUpPanelState(this.props.adminToolState, this.props.panelName, this.props.isDisplayed);
    }
    render() {
        let panel:IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let errors:string[] = AdminToolPanelHelper.GetErrorMessagesFromState(panel);
        let displayed:boolean = AdminToolPanelHelper.IsPanelDisplayed(panel);

        let getList:IExportZip[] = AdminToolPanelHelper.GetPanelValueFromState(panel, "ziplist") as IExportZip[];
        getList = getList || [];
        
        var mapResults = getList.map((item: IExportZip, index: any) => {
            return (<div className="download-item">
                <a download={item.fileName} href={item.file}><i className="ms-Icon ms-Icon--Download"></i> Download {item.fileName}</a>
            </div>)
        });

        return <div className="ziplist admintool-panelcontainer">
            <PanelHeader panelName={this.props.panelName} panelTitle={"Download Links"} enableToggle={true} isEnabled={true} adminToolState={this.props.adminToolState} />
            <div className="panel-content" style={!displayed ? { display: 'none' } : {}}>
                {mapResults}
                {(mapResults  && mapResults.length === 0)&& <div role="alert" className="alert alert-info"> <i className="ms-Icon ms-Icon--Download" aria-hidden="true"></i>There is currently no zip file to download.</div>}
            </div>
        </div>
    }
}




// WEBPACK FOOTER //
// ./source/ts/components/admintool/panels/ziplist.tsx